import type { ReactNode } from 'react';
import { useAuth } from '../auth/useAuth';
import { useStolStore } from './store';
import { StolPanel } from './StolPanel';

/**
 * Рамка Стола НАД маршрутами (паттерн PhoneProvider, жалоба владельца 13.08 про
 * обрывы при переходах): панель — свойство layout ВСЕЙ админки, экран слева
 * ужимается, но живёт. Новый раздел получает Стол автоматически — рамка
 * оборачивает все Routes, включая разделы со своим layout (Компас).
 *
 * Право stol.access — только владелец; без него панель не рендерится вовсе
 * (замок на бэке — 403, скрытие тут — только чтобы не рисовать мёртвую дверь).
 */
export function StolFrame({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const open = useStolStore((s) => s.open);
  const canStol = user?.permissions?.includes('stol.access') ?? false;

  return (
    <div className="flex h-screen w-full overflow-hidden">
      {/* overflow-auto: раздел, живший на прокрутке body (Компас), скроллится
          внутри рамки — sticky-шапки работают, панель справа не уезжает.
          id — якорь захвата «Показать экран» (snapshot.ts). */}
      <div id="stol-screen-root" className="h-full min-w-0 flex-1 overflow-auto">
        {children}
      </div>
      {canStol && open && <StolPanel />}
    </div>
  );
}
